import React from "react";

const KeyboardOutput = ({ text }) => {
    return (
        <div className='flex px-4 items-center max-w-[850px] text-2xl w-full h-[70px] rounded-lg mx-auto bg-[#3e3e3e]'>
            {text}
        </div>
    );
};

export default KeyboardOutput;
